export const LIST_CAPS = {
	payInThree: 12,
	closedPayInThree: 6,
	deferredPayments: 12,
	closedDeferredPayments: 6,
	installments: 12,
	applicationsInProgress: 4,
	cards: 4,
	transactions: 12,
	offers: 8,
	orderItemNames: 3,
	currentOrderItemNames: 12,
} as const;
